require( 'owl.carousel' );
require( 'jq-accordion' );
import 'magnific-popup';
import '../../node_modules/jquery.marquee/jquery.marquee';

import nav from './modules/nav';
import marquee from './modules/marquee';
import home from './modules/home';
import room from './modules/room';
import service from './modules/service';
import about from './modules/about';

jQuery( document ).ready(function($) {

  nav();

  marquee();

  if ($('body').hasClass('page-template-home')) {
    home();
  }

  if ($('body').hasClass('page-template-room')) {
    room();
  }

  if ($('body').hasClass('page-template-service')) {
    service();
  }

  if ($('body').hasClass('page-template-about')) {
    about();
  }

});